import createGetFormSyncErrors from '../selectors/getFormSyncErrors';
import immutable from '../structure/immutable';

export default createGetFormSyncErrors(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/getFormSyncErrors.js
// module id = 1200
// module chunks = 0